import { useAppSelector } from '@/store/hooks';
import { selectFeatureFlag } from '@/store/slices/feature-flags/selectors';
import { FeatureFlagsEnum } from '@/store/slices/feature-flags/types';
import { ChannelFeaturesEnum } from '@/types/feature-flags.types';
import { PATHNAMES } from '@/utils/pathnames';
import { getBaseAdminURL } from '@/utils/urls';
import useCanUseChannelFeature from '@/utils/use-can-use-channel-features';

export const useHomepageLink = (Pathname?: string) => {
  const usePJDHomepage = useAppSelector(selectFeatureFlag(FeatureFlagsEnum.platform_port_admin_homepage));
  const brandtvPJDSyncEnabled = useCanUseChannelFeature(ChannelFeaturesEnum.btv_pjd_link);
  const BRAND_TV_DOMAIN = import.meta.env.VITE_BRAND_TV_DOMAIN;

  if (brandtvPJDSyncEnabled && BRAND_TV_DOMAIN && !Pathname) {
    return `https://${BRAND_TV_DOMAIN}`;
  }

  if (usePJDHomepage) {
    return Pathname || PATHNAMES.Admin.Projects;
  }

  return getBaseAdminURL();
};
